import styled, { css } from 'styled-components';
import { StyledArcProps } from './types';
import { DataPoint } from '../DataPoint';
import { Theme } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledArc = styled(DataPoint)<StyledArcProps>`
  ${({ $hasStroke, $theme }) =>
    $hasStroke
      ? css`
          path {
            stroke-width: 2px;
            stroke: var(--redsift-color-neutral-${$theme === Theme.light ? 'white' : 'x-dark-grey'});
          }
        `
      : ''}

  ${({ $clickable }) =>
    $clickable
      ? css`
          cursor: pointer;

          &:hover,
          &:focus,
          &.focused {
            opacity: 0.8;
            outline: none;
          }

          &:focus-visible,
          &.focused {
            path {
              stroke: var(--redsift-color-primary-n);
              stroke-width: 4px;
              paint-order: stroke;
            }
          }
        `
      : ''}
`;
